import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

const CustomCheckbox = ({ label, checked = false, onChange, size = 'medium', disabled = false, style = {} }) => {
  // 기본 스타일
  const defaultStyle = {
    checkbox: {
      padding: 0.5,
      marginTop: '-1px',
      color: '#ddd',
      '&.Mui-checked': {
        color: '#0C8CE9',
      },
      ...style.checkbox,
    },
    label: {
      justifyContent: 'center',
      margin: 0,
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#767676',
      },
      ...style.label,
    },
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox checked={checked} onChange={onChange} size={size} disabled={disabled} sx={defaultStyle.checkbox} />
        }
        label={label}
        sx={defaultStyle.label}
      />
    </FormGroup>
  );
};

export default CustomCheckbox;
